(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("userHubService", ["$rootScope", "$timeout", userHubService]);
    function userHubService($rootScope, $timeout) {
        var factory = {
            userToken: ""
        };
        var connection = new signalR.HubConnectionBuilder()
            .withUrl("/userhub", {
            accessTokenFactory: function () { return factory.userToken; },
        })
            .configureLogging(signalR.LogLevel.Information)
            .build();
        //const connection = new signalR.HubConnectionBuilder()
        //	.withUrl("/userhub", {
        //		skipNegotiation: true,
        //		transport: signalR.HttpTransportType.WebSockets
        //	})
        //	.build();
        connection.on("RefreshLearningPlan", function () {
            console.log("SignalR - RefreshLearningPlan");
            $rootScope.$broadcast("RefreshLearningPlan");
        });
        connection.on("RefreshLearningPath", function () {
            console.log("SignalR - RefreshLearningPath");
            $rootScope.$broadcast("RefreshLearningPath");
        });
        connection.on("RefreshCheckout", function (data) {
            console.log("SignalR - RefreshCheckout", data);
            $rootScope.$broadcast("RefreshCheckout", data);
        });
        connection.on("RefreshUserNotifications", function () {
            console.log("SignalR - RefreshUserNotifications");
            $rootScope.$broadcast("RefreshUserNotifications");
        });
        connection.on("UserSignedIn", function () {
            console.log("SignalR - UserSignedIn");
            $rootScope.$broadcast("UserSignedIn");
        });
        connection.on("UserSignedOut", function () {
            console.log("SignalR - UserSignedOut");
            $rootScope.$broadcast("SignalRUserSignedOut");
        });
        connection.on("ShowPointsCollectedNotification", function (data) {
            console.log("SignalR - ShowPointsCollectedNotification", data);
            $rootScope.$broadcast("ShowPointsCollectedNotification", data);
        });
        connection.on("ShowTierAchievedNotification", function (data) {
            console.log("SignalR - ShowTierAchievedNotification", data);
            $rootScope.$broadcast("ShowTierAchievedNotification", data);
        });
        factory.start = function (authentication, callback) {
            if (authentication) {
                factory.userEmail = authentication.userEmail;
                factory.userToken = authentication.token;
            }
            else {
                factory.userEmail = "";
                factory.userToken = "";
            }
            console.log("[hubService] start");
            $timeout(function () {
                try {
                    connection.start();
                    factory.isConnected = true;
                    factory.disconnectedCount = 0;
                    console.log("[hubService] start success");
                    if (callback)
                        callback();
                }
                catch (error) {
                    factory.isConnected = false;
                    console.error("[hubService] start fail: Unable to Connect: User agent: " + navigator.userAgent + " [error]: " + error);
                }
            }, 500);
        };
        factory.stop = function (callback) {
            //stopCalled = true;
            connection.stop();
            factory.isConnected = false;
            factory.disconnectedCount = 0;
            if (callback)
                callback();
        };
        //factory.onRefreshUserNotifications = function (callback) {
        //	return hubService.addCallback("userHub", "onRefreshUserNotifications", callback);
        //};
        //factory.onRefreshLearningPath = function (callback) {
        //	return hubService.addCallback("userHub", "onRefreshLearningPath", callback);
        //};
        //factory.onRefreshLearningPlan = function (callback) {
        //	return hubService.addCallback("userHub", "onRefreshLearningPlan", callback);
        //};
        //factory.onRefreshCheckout = function (callback) {
        //	return hubService.addCallback("userHub", "onRefreshCheckout", callback);
        //};
        //factory.onUserSignedIn = function (callback) {
        //	return hubService.addCallback("userHub", "onUserSignedIn", callback);
        //};
        //factory.onUserSignedOut = function (callback) {
        //	return hubService.addCallback("userHub", "onUserSignedOut", callback);
        //};
        ////GAMIFICATION
        //factory.onShowPointsCollectedNotification = function (callback) {
        //	//register only if user is a learner
        //	if (authService.authentication.isLearner)
        //		return hubService.addCallback("userHub", "onShowPointsCollectedNotification", callback);
        //	return null;
        //};
        //factory.onShowTierAchievedNotification = function (callback) {
        //	//register only if user is a learner
        //	if (authService.authentication.isLearner)
        //		return hubService.addCallback("userHub", "onShowTierAchievedNotification", callback);
        //	return null;
        //};
        return factory;
    }
}());
